import React, { useState } from 'react';
import { ReactComponent as SearchIcon } from '../Assets/search-icon.svg';
import useDebounce from '../Hooks/useDebounce';
import useUpdateEffect from '../Hooks/useUpdateEffect';

const PageTop = (props: Props) => {
  const [search, setSearch] = useState(() => props.searchValue || '');
  const debouncedValue = useDebounce<string>(search);

  function handleSearchChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSearch(e.target.value);
  }

  

  useUpdateEffect(() => {
    props.onSearch?.(debouncedValue.trim());
  }, [debouncedValue]);

  return (
    <div>
      <div
        className={`relative mb-3 mt-0 flex flex-col justify-between gap-4 rounded border border-[#9B111E] bg-[#FFF] p-[15px] md:mt-[40px] md:flex-row md:items-center md:gap-0 md:rounded-[5px] md:px-6 md:py-7 ${
          props.classNames ? props.classNames : ''
        }`}
      >
        <div className={`flex flex-col gap-1  md:gap-1.5`}>
          <div className='flex items-center gap-2'>
            <p className='text-base font-semibold xl:leading-3'>
              {props.header}
            </p>
            <p className='bg-[#F5FFF8] px-2 text-xs font-normal text-[#366B45] xl:leading-3'>
              {props.tableCount}
            </p>
          </div>
          {props.subText && (
            <p className='text-sm font-normal text-[#667085]'>
              {props.subText}
            </p>
          )}
        </div>
        <div className='items-center md:flex md:gap-4'>
          {props.onSearch && (
            <div className='relative flex w-[100%] items-center'>
              <SearchIcon className='absolute left-[14px]' />
              <input
                className={
                  'h-11 w-[100%] rounded-lg border-2 border-[#D0D5DD] pl-[40px] pr-5 text-sm outline-none focus:border-[#9B111E] focus:transition focus:delay-500 focus:ease-in-out'
                }
                type='search'
                placeholder={'Search'}
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

type Props = {
  header: string;
  subText?: string | React.ReactNode;
  tableCount?: string;
  searchValue?: string;
  onSearch?: (search: string) => void;
  filterDate?: (range: { startDate: string; endDate: string }) => void;
  defaultDate?: { startDate: Date; endDate: Date };
  openFilter?: () => void;
  isFiltered?: boolean;
  showFilter?: boolean;
  classNames?: string;
};

export default PageTop;
